/**
 * @file: useStoreFeature.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useCurrentUser } from '@euler/app/flows/auth/context';
import { StoreFeature } from '@euler/model/enum';
import { useCallback, useMemo } from 'react';
import { StoreFeatureAccess, storeFeatureAccessOf } from './storeFeatureAccess';

/** Whether the signed-in store may use the feature, and until when. */
export function useStoreFeature(feature: StoreFeature): StoreFeatureAccess {
  const user = useCurrentUser();
  const entitlements = user?.entitlements;
  return useMemo(
    () => storeFeatureAccessOf(entitlements, feature),
    [entitlements, feature],
  );
}

/** As `useStoreFeature`, for a list that checks several features. */
export function useStoreFeatureLookup(): (
  feature: StoreFeature,
) => StoreFeatureAccess {
  const user = useCurrentUser();
  const entitlements = user?.entitlements;
  return useCallback(
    (feature: StoreFeature) => storeFeatureAccessOf(entitlements, feature),
    [entitlements],
  );
}
